export default __webpack_public_path__ + "static/media/274.851db274.jpg";